module.exports = __webpack_public_path__ + "img/imgjiebtx-1.910b3a01.png";